import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import UserGroupStatusBadge from "views/Account/Settings/IdpGroup/UserGroupStatusBadge";

import { ManagedUserGroupView } from "../../types";

const IdpGroupMappingTableStatusCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <UserGroupStatusBadge status={group.status} />
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableStatusCell;
